
const LoadingElement = ({ mini }) => {
  return (
    <div className="loadingElement">
        <div class={`lds-dual-ring ${mini ? "mini" : null}`}></div>
    </div>
  );
}

export default LoadingElement;
